import React from 'react';
import PropType from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';

function getButtonInfo(isListView) {
  return isListView
    ? {
        icon: 'Thumbnails',
        label: 'Grid',
      }
    : {
        icon: 'List',
        label: 'List',
      };
}

export default function GridListViewButton(props) {
  const { isListView, togglerResultView, isSubstancesContext } = props;

  if (!isSubstancesContext) {
    return null;
  }

  const { icon, label } = getButtonInfo(isListView);

  return (
    <ButtonWithIcon
      id="toggleView"
      type="link"
      linkIconSize="xs"
      className="e2e-toggle-view u-els-margin-left"
      sprite={icon}
      iconRight
      onClick={() => {
        togglerResultView();
      }}
      data-e2e="grid-list-view-button">
      {label}
    </ButtonWithIcon>
  );
}

GridListViewButton.propType = {
  isListView: PropType.bool.isRequired,
  togglerResultView: PropType.func.isRequired,
  isSubstancesContext: PropType.bool.isRequired,
};
